<script>
    export let params = {}; // router
    import { onMount, onDestroy } from "svelte";
    import { catalog, api_url } from "../stores.js";
    import { push } from "svelte-spa-router";
    import { fade } from "svelte/transition";
    import Param from "./Param.svelte";
    import Modals from "./Modals.svelte";
    import TempLampshadeStuff from "./TempLampshadeStuff.svelte";
    import UIdataJson from "./UIdataJson.svelte";

    import { Button, Loading } from "carbon-components-svelte";
    import {
        regenerateModel,
        controlVisualisation,
        initialiseScene,
        positionCamera,
        initialiseModel,
        concludeModel,
    } from "../visualize.js";
    import "carbon-components-svelte/css/g100.css";
    import ChevronDown from "carbon-icons-svelte/lib/ChevronDown.svelte";
    import ChevronUp from "carbon-icons-svelte/lib/ChevronUp.svelte";
    let modalsComponent, UIdataComponent, tempLampshadeStuff;

    let activeModel,
        UIparamsVis = {},
        UIparamsPrinter = {},
        designParams = {},
        visParams = { plotType: "line" }, // this is required - it is used in visualize.js since a tube plotType may be used in the future
        printerParams = {},
        annotations = null,
        generating = false,
        showPrinter,
        showVisuals,
        showDesignParams,
        showDesignAdvParams,
        changed = false,
        advancedParams = 0,
        printerScrollHeight = window.innerHeight - 320 /* trial and error */,
        visualsScrollHeight = window.innerHeight - 320 /* trial and error */,
        designScrollHeight = window.innerHeight - 320 /* trial and error */,
        designAdvScrollHeight = window.innerHeight - 320 /* trial and error */,
        scrollHeightMin = 300 /* trial and error to make sure a dropdown list is visible enough*/,
        colorNow = "rgb(171, 171, 171)",
        counter = 0,
        brightness;
    const colorShift = setInterval(() => {
        counter += 0.05;
        brightness = 155 + 100 * Math.sin(counter * 2 * Math.PI);
        colorNow = "rgb(" + 55 + "," + brightness + ", " + brightness + ")";
    }, 100);

    const iterableParams = (params) => {
        return Object.entries(params).map((x) => ({
            ...{ id: x[0], ...x[1] },
        }));
    };
    const openCatalog = () => {
        if (!generating) {
            push("/models");
        }
    };

    const dropdownItemsArray = (keys) => keys.map((x) => ({ id: x }));
    const visualise = async () => {
        generating = true;
        changed = false;
        const response = await fetch($api_url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                model: activeModel.id,
                action: "visualize",
                designParams: designParams,
                printerParams: printerParams,
            }),
        });
        const data = await response.json();
        // console.log(data);
        regenerateModel(designParams, data, visParams);
        if (data.annotations.length > 0) {
            annotations = true;
        } else {
            annotations = null;
        }
        generating = false;
    };
    let gcode = async () => {
        generating = true;
        modalsComponent.modalGcode();
        const response = await fetch($api_url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                model: activeModel.id,
                action: "gcode",
                designParams: designParams,
                printerParams: printerParams,
            }),
        });
        const blob = await response.blob();
        generating = false;
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download =
            activeModel.name +
            "_D" +
            new Date().toJSON().slice(0, 10) +
            "_T" +
            new Date().toJSON().slice(11, 19) +
            ".gcode";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blob);
    };

    const updateVis = () => controlVisualisation(visParams);
    const resetVis = () => positionCamera();
    onMount(async () => {
        UIparamsVis = UIdataComponent.UIdata["vis"];
        UIparamsPrinter = UIdataComponent.UIdata["printer"];
        generating = true;
        if (!$catalog.length) {
            const response = await fetch($api_url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    action: "catalog",
                }),
            });
            const data = await response.json();
            $catalog = data;
        }
        generating = false;
        activeModel = $catalog.filter((x) => x.id == params.id)[0];
        Object.keys(activeModel.params.properties).forEach(
            (x) => (designParams[x] = activeModel.params.properties[x].default)
        );
        Object.keys(activeModel.params.properties).forEach(
            (x) => (advancedParams += activeModel.params.properties[x].advanced)
        );
        // load default visualisation values (not model specific)
        Object.keys(UIparamsVis).forEach(
            (x) => (visParams[x] = UIparamsVis[x]["default"])
        );
        // load model-specific default visualisation values
        Object.keys(activeModel.initial_visuals).forEach(
            (x) => (visParams[x] = activeModel.initial_visuals[x])
        );
        // load default printer settings values (not model specific)
        Object.keys(UIparamsPrinter).forEach(
            (x) => (printerParams[x] = UIparamsPrinter[x]["default"])
        );

        if (activeModel.id == "ebdc86") {
            gcode = async () => {
                tempLampshadeStuff.modalLampshade();
            };
        }

        initialiseModel();
        initialiseScene();
        visualise();
        setClickEvents();
    });
    onDestroy(() => {
        concludeModel();
    });
    const setClickEvents = () => {
        (showPrinter = null),
            (showVisuals = null),
            (showDesignParams = true),
            (showDesignAdvParams = null);
        document.getElementById("printTitle").onclick = togglePrinter;
        document.getElementById("visualsTitle").onclick = toggleVisuals;
        document.getElementById("designTitle").onclick = toggleParams;
        if (advancedParams > 0) {
            document.getElementById("designAdvTitle").onclick = toggleParamsAdv;
        }
    };
    const toggleVisuals = () => {
        showVisuals = !showVisuals;
        if (showVisuals) {
            showPrinter = null;
        }
    };
    const togglePrinter = () => {
        showPrinter = !showPrinter;
        if (showPrinter) {
            showVisuals = null;
        }
    };
    const toggleParams = () => {
        showDesignParams = !showDesignParams;
        if (showDesignParams) {
            showDesignAdvParams = null;
        }
    };
    const toggleParamsAdv = () => {
        showDesignAdvParams = !showDesignAdvParams;
        if (showDesignAdvParams) {
            showDesignParams = null;
        }
    };
</script>

<UIdataJson bind:this={UIdataComponent} />
<Modals bind:this={modalsComponent} />
<TempLampshadeStuff bind:this={tempLampshadeStuff} />
<body in:fade={{ delay: 500 }} out:fade>
    <div id="return" on:click={openCatalog}>
        <span style="font-size:20px">&larr;</span>
        back to library
    </div>
    <div id="about" on:click={modalsComponent.modalAbout}>About</div>
    <div
        id="python"
        style="color:{colorNow}"
        on:click={modalsComponent.modalPython}
    >
        python design
        <span style="font-size:20px">&rarr;</span>
    </div>
    <div id="visualisation">
        <div id="target" />
        {#if generating}
            <div id="status" in:fade out:fade>
                <Loading />
            </div>
        {/if}
    </div>
    <div id="title">
        {#if activeModel}<h1>{activeModel.name}</h1>{/if}
    </div>
    <div id="design">
        <div id="params">
            <div id="designTitle">
                <div id="sectHead">
                    Design Parameters
                    <p style="direction: rtl">
                        {#if showDesignParams}<ChevronUp />{:else}<ChevronDown
                            />{/if}
                    </p>
                </div>
            </div>
            {#if showDesignParams}
                <div
                    id="paramsScroll"
                    style="max-height: {designScrollHeight}px;min-height: {scrollHeightMin}px;"
                >
                    {#if activeModel}
                        <!-- loop through params twice, to implement sorting, this code will be tidied -->
                        {#each iterableParams(activeModel.params.properties) as param_loop, i}
                            {#each iterableParams(activeModel.params.properties) as param}
                                {#if param.sort - 1 == i && param.advanced == false}
                                    <Param
                                        type={"designParam"}
                                        bind:paramElement={designParams[
                                            param.id
                                        ]}
                                        bind:paramProperties={param}
                                        bind:scrollHeightMin
                                        bind:changed
                                        {updateVis}
                                    />
                                {/if}
                            {/each}
                        {/each}
                    {/if}
                </div>
            {/if}
            <br />
            <div id="designAdvTitle">
                {#if advancedParams > 0}
                    <div id="sectHead">
                        Advanced Design Parameters
                        <p style="direction: rtl">
                            {#if showDesignAdvParams}<ChevronUp
                                />{:else}<ChevronDown />{/if}
                        </p>
                    </div>
                {/if}
            </div>
            {#if advancedParams > 0}
                {#if showDesignAdvParams}
                    <div
                        id="paramsAdvScroll"
                        style="max-height: {designAdvScrollHeight}px;min-height: {scrollHeightMin}px;"
                    >
                        {#if activeModel}
                            <!-- loop through params twice, to implement sorting, this code will be tidied -->
                            {#each iterableParams(activeModel.params.properties) as param_loop, i}
                                {#each iterableParams(activeModel.params.properties) as param}
                                    {#if param.sort - 1 == i && param.advanced == true}
                                        <Param
                                            type={"designParam"}
                                            bind:paramElement={designParams[
                                                param.id
                                            ]}
                                            bind:paramProperties={param}
                                            bind:scrollHeightMin
                                            bind:changed
                                            {updateVis}
                                        />
                                    {/if}
                                {/each}
                            {/each}
                        {/if}
                    </div>
                {/if}
            {/if}
        </div>
        <br />
        {#if generating}
            <Button disabled on:click={visualise}>Regenerate Design</Button>
        {:else if !changed}
            <Button disabled on:click={visualise}>Regenerate Design</Button>
        {:else}
            <Button on:click={visualise}>Regenerate Design</Button>
        {/if}
    </div>
    <div id="visualsAndPrinter">
        <div id="visuals">
            <div id="visualsTitle">
                <div id="sectHead">
                    Visual Controls
                    <p style="direction: rtl">
                        {#if showVisuals}<ChevronUp />{:else}<ChevronDown
                            />{/if}
                    </p>
                </div>
            </div>
            {#if showVisuals}
                <div
                    id="visualsScroll"
                    style="max-height: {visualsScrollHeight}px;min-height: {scrollHeightMin}px;"
                >
                    {#if UIparamsVis}
                        <!-- loop through params twice, to implement sorting, this code will be tidied -->
                        {#each iterableParams(UIparamsVis) as param_loop, i}
                            {#each iterableParams(UIparamsVis) as param}
                                {#if param.sort - 1 == i}
                                    <Param
                                        type={"visParam"}
                                        bind:paramElement={visParams[param.id]}
                                        bind:paramProperties={param}
                                        bind:scrollHeightMin
                                        bind:changed
                                        {updateVis}
                                    />
                                {/if}
                            {/each}
                        {/each}
                    {/if}
                </div>
            {/if}
        </div>
        <br />
        <div align="right">
            {#if generating}
                <Button disabled on:click={resetVis}>Reset model view</Button>
            {:else}
                <Button on:click={resetVis}>Reset model view</Button>
            {/if}
        </div>
        <br />
        <div id="printer">
            <div id="printTitle">
                <div id="sectHead">
                    Printer Parameters
                    <p style="direction: rtl">
                        {#if showPrinter}<ChevronUp />{:else}<ChevronDown
                            />{/if}
                    </p>
                </div>
            </div>
            {#if showPrinter}
                <div
                    id="printerScroll"
                    style="max-height: {printerScrollHeight}px;min-height: {scrollHeightMin}px;"
                >
                    {#if UIparamsPrinter}
                        <!-- loop through params twice, to implement sorting, this code will be tidied -->
                        {#each iterableParams(UIparamsPrinter) as param_loop, i}
                            {#each iterableParams(UIparamsPrinter) as param}
                                {#if param.sort - 1 == i}
                                    <Param
                                        type={"printerParam"}
                                        bind:paramElement={printerParams[
                                            param.id
                                        ]}
                                        bind:paramProperties={param}
                                        bind:scrollHeightMin
                                        bind:changed
                                        {updateVis}
                                    />
                                {/if}
                            {/each}
                        {/each}
                    {/if}
                </div>
            {/if}
        </div>
        <br />
        <div align="right">
            {#if generating}
                <Button disabled on:click={gcode}>Download GCode</Button>
            {:else}
                <Button on:click={gcode}>Download GCode</Button>
            {/if}
        </div>
    </div>
    <div class="overlay" />
</body>

<svelte:head>
    <meta name="viewport" content="width=1024" />
</svelte:head>

<style>
    @import url("https://fonts.cdnfonts.com/css/mayeka-demo");
    body {
        font-family: "Mayeka Regular Demo", Arial, sans-serif;
    }
    body * {
        user-select: none;
    }
    h1 {
        font-size: 35px;
    }
    #paramsAdvScroll::-webkit-scrollbar,
    #paramsScroll::-webkit-scrollbar,
    #printerScroll::-webkit-scrollbar,
    #visualsScroll::-webkit-scrollbar {
        width: 10px;
    }
    #paramsAdvScroll::-webkit-scrollbar-track,
    #paramsScroll::-webkit-scrollbar-track,
    #printerScroll::-webkit-scrollbar-track,
    #visualsScroll::-webkit-scrollbar-track {
        /* background: black; */
        background: rgb(255, 255, 255, 0);
    }
    #paramsAdvScroll::-webkit-scrollbar-thumb,
    #paramsScroll::-webkit-scrollbar-thumb,
    #printerScroll::-webkit-scrollbar-thumb,
    #visualsScroll::-webkit-scrollbar-thumb {
        background: #333333;
        border-radius: 10px;
    }
    #paramsAdvScroll::-webkit-scrollbar-thumb:hover,
    #paramsScroll::-webkit-scrollbar-thumb:hover,
    #printerScroll::-webkit-scrollbar-thumb:hover,
    #visualsScroll::-webkit-scrollbar-thumb:hover {
        background: #444444;
        /* background: rgb(255, 255, 255, 0.04); */
    }

    #about {
        font-size: medium;
        /* position: absolute; */
        float: right;
        color: rgb(171, 171, 171);
        z-index: 3;
        right: 10px;
        padding-top: 10px;
        cursor: pointer;
        position: fixed;
    }
    #python {
        font-size: medium;
        font-style: italic;
        float: right;
        color: rgb(171, 171, 171);
        z-index: 3;
        right: 10px;
        padding-top: 10px;
        bottom: 10px;
        cursor: pointer;
        position: fixed;
    }
    #visualisation {
        z-index: 1;
        width: 100%;
        position: absolute;
        background-color: black;
    }
    #target {
        width: 100vw;
        height: 100vh;
        font-family: Arial, sans-serif;
        /* Arial used instead of Mayeka Regular Demo because it doesn't show period symbols correctly */
    }
    #status {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        z-index: 10;
        text-align: center;
        top: 0;
        left: 0;
        position: fixed;
        padding: 40vh 0;
        pointer-events: none;
        display: block;
    }

    .overlay {
        position: fixed;
        top: 0px;
        left: 0px;
        height: 100%;
        background: rgba(0, 255, 0, 0.5);
    }
    /* #statusText {
        text-shadow: 0 0 2px #000, 0 0 5px #000, 0 0 10px #000, 0 0 20px #000;
        padding-bottom: 30px;
    } */
    #return {
        font-style: italic;
        font-size: medium;
        position: absolute;
        float: left;
        color: rgb(171, 171, 171);
        z-index: 3;
        left: 10px;
        padding-top: 10px;
        cursor: pointer;
    }
    #title {
        position: relative;
        text-align: center;
        z-index: 2;
        padding-top: 20px;
    }
    #sectHead {
        padding: 10px;
        font-size: large;
        color: lightgrey;
        cursor: pointer;
        background-color: rgb(44, 44, 44);
    }
    #sectHead:hover {
        background-color: rgb(66, 66, 66);
    }
    #design {
        width: 360px;
        position: relative;
        float: left;
        color: lightgrey;
        left: 2%;
        z-index: 2;
        padding-top: 20px;
    }
    #paramsScroll {
        overflow-y: scroll;
    }
    #paramsAdvScroll {
        overflow-y: scroll;
    }
    #visualsAndPrinter {
        width: 360px;
        position: relative;
        float: right;
        color: lightgrey;
        z-index: 2;
        right: 2%;
        padding-top: 20px;
    }
    #visuals {
        background-color: rgb(255, 255, 255, 0.04);
    }
    #printer {
        background-color: rgb(255, 255, 255, 0.04);
    }
    #params {
        background-color: rgb(255, 255, 255, 0.04);
    }
    #visualsScroll {
        overflow-y: scroll;
    }
    #printerScroll {
        overflow-y: scroll;
    }
</style>
